import React from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
const Container = styled.div.withConfig({
  displayName: "SelectionComponentAnimationTint__Container",
  componentId: "sc-1odging-0"
})(["display:grid;grid-template-columns:repeat(8,1fr);grid-column-gap:8px;grid-row-gap:8px;margin-bottom:20px;margin-left:10px;margin-top:10px;"]);
const ColorSelectionItem = styled.div.withConfig({
  displayName: "SelectionComponentAnimationTint__ColorSelectionItem",
  componentId: "sc-1odging-1"
})(["width:34px;height:34px;background-color:", ";border:black 4px solid;cursor:pointer;&.selected{border:cadetblue 4px solid;}"], props => props.color);
export const SelectionComponentAnimationTint = observer(props => {
  return /*#__PURE__*/React.createElement(Container, null, props.hexColors.map(hexColor => /*#__PURE__*/React.createElement(ColorSelectionItem, {
    key: hexColor,
    color: hexColor,
    className: props.store.selectedCharacterConfiguration.tintColorHex == hexColor ? "selected" : "",
    onClick: _ => {
      props.onColorSelectionChange(hexColor);
    }
  })));
});